var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-breadcrumb', {
    staticClass: "app-levelbar",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.levelList), function(item, index) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [(item.redirect === "noredirect" || index == _vm.levelList.length - 1) ? _c('router-link', {
      staticClass: "no-redirect",
      attrs: {
        "to": ""
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('router-link', {
      attrs: {
        "to": item.redirect || item.path
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }))
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4a0bc5c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a0bc5c6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Levelbar.vue
// module id = 3p1m
// module chunks = 212